import React, {useRef} from 'react';
import styled from "styled-components";
import ModalLayout from "@layouts/modal";
import {isEmpty} from "@helpers/helpers";
import Icon from "@atoms/icon";
import ButtonBase from "@atoms/button.base";
import StatIcon4 from '@icons/services/stat04.svg';
import PinterestIcon from '@icons/social/pinterest.svg';
import WhatsappIcon from '@icons/social/whatsapp.svg';
import TelegramIcon from '@icons/social/telegram.svg';

let set_timeout = null;
const Share = ({property, isBadeSaba, show, setShow}) => {
    const copyTooltipRef = useRef('');
    const linkRef = useRef('');
    const propertyShortLink = ((!isEmpty(property.short_link)) ? ('2nabsh.com/s/' + property.short_link) : '') + (isBadeSaba ? '?badesaba=true' : '');

    const telegramShareUrl = 'https://telegram.me/share/url?url=https://' + propertyShortLink;
    const whatsappShareUrl = 'https://wa.me/?text=https://' + propertyShortLink;
    const pinterestShareUrl = 'http://pinterest.com/pin/create/button/?url=https://' + propertyShortLink;

    const copyToClipboard = () => {
        const value = linkRef.current.innerText;

        if (!isEmpty(set_timeout)) {
            clearTimeout(set_timeout)
        }

        const temp = document.createElement('input');
        temp.value = value;
        temp.style.position = 'absolute';
        document.body.prepend(temp);

        temp.select();

        document.execCommand('copy');
        document.body.removeChild(temp);

        copyTooltipRef.current.classList.remove('d-none');
        copyTooltipRef.current.classList.add('show');

        set_timeout = setTimeout(() => {
            copyTooltipRef.current.classList.add('d-none');
            copyTooltipRef.current.classList.remove('show');
        }, 2000)
    };

    return (
        <ModalLayout show={show} setShow={setShow} modalDialogClass="modal-sm">
            <div className="text-center pb-40 mt-8 mt-lg-0 pb-lg-0">
                <h3 className="h2">اشتراک‌گذاری</h3>
                <p className="mt-32">این ملک رو با دیگران به اشتراک بذارین</p>

                <Icon width={132} className=" mt-8 state-icon"><StatIcon4/></Icon>

                <div className="position-relative d-flex align-items-center justify-content-between p-4 border border-gray250 rounded-8 mt-8">
                    <CopyTooltip ref={copyTooltipRef} className="d-none tooltip-inner">
                        <span className="arrow"/>
                        کپی شد
                    </CopyTooltip>

                    <ButtonBase size="sm" className="h6-normal font-weight-500 flex-none" onClick={() => copyToClipboard()}>کپی لینک</ButtonBase>

                    <div className="font-weight-bold px-16 font-arial text-ellipsis ltr" ref={linkRef} onClick={() => copyToClipboard()}>{(!isEmpty(property.short_link)) ? propertyShortLink : ''}</div>
                </div>

                <div className="mt-32 mt-lg-40 row align-items-center">
                    <a href={telegramShareUrl} target="_blank" className="col-4 text-center js-track-share-on-telegram">
                        <Icon width={32} height={32}><TelegramIcon/></Icon>
                        <span className="d-block">تلگرام</span>
                    </a>

                    <a href={whatsappShareUrl} target="_blank" className="col-4 text-center js-track-share-on-whatsapp">
                        <Icon width={32} height={32}><WhatsappIcon/></Icon>
                        <span className="d-block">واتس‌اپ</span>
                    </a>

                    <a href={pinterestShareUrl} target="_blank" className="col-4 text-center js-track-share-on-pintrest">
                        <Icon width={32} height={32}><PinterestIcon/></Icon>
                        <span className="d-block">پینترست</span>
                    </a>
                </div>

            </div>
        </ModalLayout>
    );
};

export default React.memo(Share);

// styles

const CopyTooltip = styled.div`
    position: absolute;
    top: -28px;
    right: 24px;
    padding: 0 12px;
   // TODO:: use tooltip components
  
    opacity: 0;
    visibility: hidden;
    
    &.show {
      opacity: 1;
      visibility: visible;
      transition: all .3s ease;
    }
      
    .arrow {
        position: absolute;
        display: block;
        width: 8px;
        height: .4rem;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 6px);

        &::before {
          position: absolute;
          content: "";
          border-color: transparent;
          border-style: solid;
          top: 0;
          border-width: 4px;
          border-top-color: ${props => props.theme.secondary};
          left: 0;
          transform: translate(0px, 0px);
        }
    } 
`;
